/**
 *
 * @module currency
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class Currency
 *
 */
export default class Currency {

    /**
     *
     * @param {String} alternateId
     * @param {Number} id
     * @param {String} isoCodeAlphabetic
     * @throws {InvalidArgumentException}
     *
     */
    constructor(alternateId, id, isoCodeAlphabetic) {

        const errorMessage = {
            ctor: 'Currency(alternateId, id, isoCodeAlphabetic)',
            get alternateId() {
                return `${this.ctor} alternateId should be a String with length`;
            },
            get id() {
                return `${this.ctor} id should be a Number`;
            },
            get isoCodeAlphabetic() {
                return `${this.ctor} isoCodeAlphabetic should be a String with length`;
            }
        };

        nonEmptyString(alternateId, errorMessage.alternateId, InvalidArgumentException);
        number(id, errorMessage.id, InvalidArgumentException);
        nonEmptyString(isoCodeAlphabetic, errorMessage.isoCodeAlphabetic, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.alternateId = alternateId;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.id = id;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.isoCodeAlphabetic = isoCodeAlphabetic;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/currency.js